/* eslint-disable complexity */
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { ImageProviderService, GetAvailableImagesOptions } from '../image-provider-service';
import type { ImageItem } from '../image-selector-dialog.service';
import { ParsedFiguresApi } from '@/domains/specification/apis/parsed-figures-api';
import { CurrentTaskService } from '@/services/current-task/current-task-service';

/**
 * 图片提供服务实现
 * 基于 ParsedFiguresApi 获取已解析的图片
 */
@injectable()
export class ImageProviderServiceImpl implements ImageProviderService {
    constructor(
        @inject(ParsedFiguresApi)
        private readonly _parsedFiguresApi: ParsedFiguresApi,
        @inject(CurrentTaskService)
        private readonly _currentTaskService: CurrentTaskService,
    ) {}

    async getAvailableImages(options: GetAvailableImagesOptions = {}): Promise<ImageItem[]> {
        try {
            // 获取当前任务ID
            const taskId = options.taskId || this._currentTaskService.taskId;

            if (!taskId) {
                console.warn('No task ID available for fetching images');
                return [];
            }

            // 获取已解析的图片
            const parseResponse = await this._parsedFiguresApi.getParseImages({ taskId });

            if (!parseResponse.images || parseResponse.images.length === 0) {
                return [];
            }

            // 转换为 ImageItem 格式
            const imageItems: ImageItem[] = parseResponse.images
                .filter(image => image.s3_key) // 确保有s3Key
                .slice(0, options.maxCount || 100) // 限制最大数量
                .map((image) => ({
                    url: image.image_url,
                    s3Key: image.s3_key,
                }));

            return imageItems;
        } catch (error) {
            console.error('Failed to fetch available images:', error);

            // 发生错误时返回空数组，而不是抛出异常
            // 这样可以让对话框正常打开，只是没有可选图片
            return [];
        }
    }
}
